import { useEffect } from "react";


export const VolunteerForm = () => {

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               region: "na1",
               portalId: "536350",
               formId: "c4f0cf76-e02b-497a-a1cb-1b07b4e23aa7",
               target: '#volunteerForm',
            })
         }
      });
   });

   return (
      <div className="footer-form volunteer-form">
         <h1>Apply to Volunteer</h1>
         <div id="volunteerForm" />
      </div>
   )
}